import { useEffect, useState } from "react";
import { formatRefOutput } from "../../Utility/referenceListing";

export const RightPanelRef = ({ editor, isShow, isOpen, showRef }) => {
  const [references, setReferences] = useState([]);

  useEffect(() => {
    if (editor?.dom && isShow === "ref" && isOpen) {
      const allRefs = editor.dom.select("ref");
      const allXrefs = editor.dom.select("xref");

      if (allRefs && allRefs.length > 0) {
        const newReferences = [];

        allRefs.forEach((item) => {
          const citation = item.querySelector("mixed-citation");
          const ref = citation?.querySelector("refoutput");
          const id = item.getAttribute("id");
          const output = formatRefOutput(ref);
          if (ref && id) {
            const xrefCount = Array.from(allXrefs).filter(
              (xref) =>
                xref.getAttribute("href") === `#${id}` ||
                xref.getAttribute("rid") === id
            ).length;

            newReferences.push({
              text: output,
              id: id,
              count: xrefCount,
            });
          }
        });

        setReferences(newReferences);
      }
    }
  }, [isShow, isOpen, showRef]);

  const selectRefInEditor = (id) => {
    if (!editor || !id) return;

    const dom = editor.dom;
    const queryEle = dom.select(`ref[id="${id}"]`)[0];

    if (queryEle) {
      editor.selection.select(queryEle);
      // queryEle.focus();
      queryEle.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const xrefIndices = {};

  const handleClick = (id) => {
    const editorBody = editor?.dom;
    if (!editorBody) return;

    // Find all matching <xref href="#id">
    const xrefs = editorBody.select(`xref[href="#${id}"]`);
    if (!xrefs.length) return;

    // Initialize counter for this id if needed
    if (!xrefIndices[id]) {
      xrefIndices[id] = 0;
    }

    // Get current element to scroll
    const currentIndex = xrefIndices[id] % xrefs.length;
    const targetElement = xrefs[currentIndex];

    if (targetElement) {
      editor.selection.select(targetElement);
      targetElement.focus();
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    // Move to the next index
    xrefIndices[id] = (xrefIndices[id] + 1) % xrefs.length;
  };

  return (
    <div
      className={`w-full flex flex-col gap-4 ${
        isShow === "ref" ? "flex" : "hidden"
      }`}
    >
      <div className="border-b border-grey p-3  absolute top-0 bg-leftPanelbg inset-x-0 z-[10]">
        <h4 className="font-semibold text-primary text-[18px]">References</h4>
      </div>

      {references.length > 0 ? (
        <div className="mt-14 flex flex-col gap-3">
          {references.map((item, i) => (
              <div
                key={i}
                className="relative w-full flex  flex-col cursor-pointer bg-white rounded-md hover:bg-panelrefbg border border-grey py-2 px-[6px] hover:border-panelref "
              >
                <div
                  onClick={() => selectRefInEditor(item.id)}
                  className="flex w-full gap-[4px] pb-4"
                >
                  <span>{`[${item.id.split("-")[1]}]`}</span>
                  <p className="text-[15px] break-all">{item.text}</p>
                </div>
                <div className="flex justify-end z-9 absolute bottom-[8px] right-[8px]">
                  <span
                    onClick={() => handleClick(item.id)}
                    className="text-[12px] text-green hover:text-red "
                  >
                    cited{`(${item.count})`}
                  </span>
                </div>
              </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
